// Func = limiting Scope for this file
var lastScrollTop = 0;


(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		//Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });

		//Menu Desktop
		$('#open-menu').click(function(event){
			$('#menu-content').addClass('show');
			$('#overlay-menu').addClass('show');
		});
		$('#close-menu').click(function(event){
			$('#menu-content').removeClass('show');
			$('#overlay-menu').removeClass('show');
		});

		$('#open-booking').click(function(event){
			$('#content-booking').addClass('show');
			$('#overlay-menu').addClass('show');
		});
		$('#close-booking').click(function(event){
			$('#content-booking').removeClass('show');
			$('#overlay-menu').removeClass('show');
		});

		// $('#booking-form').click(function(event){
		// 	$(this).addClass('more-fields');
		// });

		// var booking = document.getElementById('booking-form');
		// if(booking){
		// 	//I'm using "click" but it works with any event
		// 	document.addEventListener('click', function(event) {
		// 		var isClickInside = booking.contains(event.target);
			
		// 		if (!isClickInside) {
		// 			$('#booking-form').removeClass('more-fields');
		// 		}
		// 	});
		// }
		

		//home booking
		// if(document.getElementById('home')){
		// 	document.getElementById('content__booking').classList.add('home');
		// } else {
		// 	document.getElementById('content__booking').classList.add('fixed');
		// 	document.getElementById('header').classList.add('scroll');
		// }

		// if(document.getElementById('home')){
		// 	let topcontent = document.getElementsByClassName('top-content')[0].getElementsByClassName('slide')[0].offsetHeight - 110;
		// 	$('#content__booking').css('top', topcontent);
		// }

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		// let DATE_STYLE = [true];
		// function calendarRange(date){			
		// 	let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
		// 	let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
		// 	if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
		// 		DATE_STYLE[1] = 'highlight-top';
		// 	}else if(date > d1 && date < d2){
		// 		DATE_STYLE[1] = 'highlight';
		// 	}else{
		// 		DATE_STYLE[1] = '';
		// 	}
		// 	return DATE_STYLE;
		// }

		//Check in and check out datepicker for booking engine
		// const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        // $( "#CheckIn" ).datepicker({
		// 	//showOn: "both",
		// 	//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		// 	//buttonImageOnly: true,
		// 	changeMonth: true,
        //     dateFormat: DATE_FORMAT,
        //     numberOfMonths: 1,
		// 	minDate: 0,
		// 	beforeShowDay: (date) => calendarRange(date),
		// 	onSelect: function( selectedDate ) {
		// 		let getDate = $(this).datepicker('getDate');
		// 		let newDate = new Date(getDate.getTime());
		// 		newDate.setDate(newDate.getDate() + 3);
		// 		$( "#CheckOut" ).datepicker( "setDate", newDate );
		// 		$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		// 	}
		// });
		//$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            // dateFormat: DATE_FORMAT,
            // changeMonth: true,
			// numberOfMonths: 1,
			// beforeShowDay: (date) => calendarRange(date),
			// onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			//}
		//});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		// scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})

		let inputBooking = document.querySelector('#check-in-out');
		var datepicker = new HotelDatepicker(inputBooking,{
			format: 'MM/DD/YYYY',
			showTopbar: false,
			moveBothMonths: true,
			onSelectRange: function() {
				var date_val = datepicker.getValue().split(' - ');
				console.log(date_val);
				document.getElementById('DateIn').setAttribute('value', date_val[0]);
				document.getElementById('DateOut').setAttribute('value', date_val[1]);
				$('.icon-calendar').addClass('hide');
			}
		});
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	
		// let imagesH = document.getElementsByClassName('top-content')[0].getElementsByClassName('slide')[0].offsetHeight - 180;
		if(st > 40){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('down')){
					document.getElementById('header').classList.add('down');
					document.getElementById('header').classList.remove('up');
				}
			} else {
				// upscroll code
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
				}
			}
		} else {
			if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
			}
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

		// if(st > imagesH){
		// 	document.getElementById('content__booking').classList.add('fixed');
		// 	document.getElementById('content__booking').classList.remove('home');
		// 	document.querySelector('.header').classList.add('scroll');
		// }else{
		// 	document.getElementById('content__booking').classList.remove('fixed');
		// 	document.querySelector('.header').classList.remove('scroll');
		// 	document.getElementById('content__booking').classList.add('home');
		// }
}